import { useContext, useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import { CalculosContext } from "../../contexts/CalculosContext"
import SiteContext from "../../contexts/SiteContext"
import TrocoMask from "../../masks/troco"
import TelaLogin from "../Login/index"

import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Fab from "@material-ui/core/Fab"
import IconButton from "@material-ui/core/IconButton"
import InputLabel from "@material-ui/core/InputLabel"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket"
import CadastroEndereco from "../../components/cadastroEndereco"
import DialogAcao from "./DialogAcao"
import DialogCEP from "./DialogCEP"
import DialogEnderecos from "./DialogEnderecos"
import DialogNovoEndereco from "./DialogNovoEndereco"

import Checkbox from "@material-ui/core/Checkbox"
//loading

import { makeStyles, useTheme } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Comida from "../../assets/comida.svg"
import Megafone from "../../assets/megafone.svg"

import TextField from "@material-ui/core/TextField"

import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber"
import PaymentIcon from "@material-ui/icons/Payment"

import AlertFixo from "@material-ui/lab/Alert"

import FormControl from "@material-ui/core/FormControl"
import FormControlLabel from "@material-ui/core/FormControlLabel"

import Divider from "@material-ui/core/Divider"

import Avatar from "@material-ui/core/Avatar"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import ListItemText from "@material-ui/core/ListItemText"
import EditIcon from "@material-ui/icons/Edit"
import FavoriteIcon from "@material-ui/icons/Favorite"

import ButtonGroup from "@material-ui/core/ButtonGroup"
import AddIcon from "@material-ui/icons/Add"
import InfoIcon from "@material-ui/icons/Info"
import RemoveIcon from "@material-ui/icons/Remove"

import { Switch, Tooltip } from "@material-ui/core"
import { LoginDialogContext } from "../../components/LoginDialog"
import TelefoneInputField from "../../components/TelefoneInputField"
import useParametros from "../../contexts/ParametrosContext"
import { TextosContext } from "../../contexts/TextosContext"
import {
    formatarParaDinheiro,
    identificarEstabelecimentoSelecionado,
    RegistrarLogErro,
} from "../../services/functions"
import DialogCadastroCartao from "./components/DialogCadastroCartao"
import DisplayDetalhesCartao from "./components/DisplayDetalhesCartao"
import SelecaoFormaDePagamento from "./components/SelecaoFormaDePagamento"

const useStyles = makeStyles(theme => ({
    botoes_container: {
        display: "flex",
        "& > button": {
            flex: 1,
            color: "white",
        },
        "& > button:nth-child(1)": {
            backgroundColor: "#dc3545",
        },
        "& > button:nth-child(2)": {
            backgroundColor: "#28a745",
        },
    },
    containerCpfObservacoes: {
        display: "flex",
        gap: "0.5rem",
        margin: "0.75rem 0",
        flexWrap: "wrap",
        " & > *": {
            border: "1px solid rgba(0, 0, 0, 0.23)",
            borderRadius: "4px",
        },
        " & > *:hover": {
            borderColor: "rgba(0, 0, 0, 0.87)",
        },
        "& .container-cpf-email": {
            display: "grid",
            gridTemplateColumns: "1fr min-content fit-content(100%)",
            [theme.breakpoints.down("xs")]: {
                gridTemplateColumns: "1fr",
            },
            alignItems: "center",
            flex: "99 1 min(100%, 24rem)",
            "& > div": {
                display: "flex",
                flexDirection: "column",
                padding: "0 0.5rem",
                "& > div": {
                    display: "grid",
                    gridTemplateColumns: "1fr min-content",
                    alignItems: "center",
                    justifyContent: "space-between",
                    "& > input, span": {
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    },
                },
            },
            "& > button": { margin: "0.25rem 0.5rem" },
        },
        "& .container-cpf-nota": {
            display: "flex",
            flexWrap: "wrap",
            flex: "1 0 min(100%, 8rem)",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingInline: "0.5rem",
            border: "1px solid rgba(0, 0, 0, 0.23)",
            borderRadius: "4px",
            textWrap: "nowrap",
            "&:hover": {
                borderColor: "rgba(0, 0, 0, 0.87)",
            },
            [theme.breakpoints.down("sm")]: {
                flexDirection: "row",
                width: "100%",
            },
        },
        "& .container-observacoes": {
            display: "grid",
            gridTemplateColumns: "1fr min-content",
            alignItems: "center",
            flex: "99 0 min(100%, 16rem)",
            padding: 0,
            border: "1px solid rgba(0, 0, 0, 0.23)",
            borderRadius: "4px",
            "&:hover": {
                borderColor: "rgba(0, 0, 0, 0.87)",
            },
            "& > span": {
                margin: "0 0.5rem",
                padding: "0.25rem",
            },
            "& > button": {
                height: "100%",
                width: "100%",
                padding: "0.5rem 0.5rem",
            },
        },
        "& .container-comer-no-local": {
            flex: "1 0 min(100%, 8rem)",
            padding: "0 0.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid rgba(0, 0, 0, 0.23)",
            borderRadius: "4px",
            whiteSpace: "nowrap",
            "&:hover": {
                borderColor: "rgba(0, 0, 0, 0.87)",
            },
            "& > .checkbox-comer-no-local": {
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
                margin: 0,
                "& > label": {
                    margin: 0,
                },
            },
        },
    },
    observacao: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
}))

const DialogObservacoes = props => {
    const classes = useStyles()

    const { textos } = useContext(TextosContext)

    const [observacao, setObservacao] = useState(props.textoObservacao)

    const handleChange = e => setObservacao(e.target.value)

    const handleClose = () => {
        props.setAbrirObservacoes(false)
        props.setTextoObservacao(observacao)
    }

    const handleCancel = () => props.setAbrirObservacoes(false)

    return (
        <Dialog open={props.abrirObservacoes} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle>
                <IconButton className="setaVoltarModal" onClick={handleClose}>
                    <ArrowForwardIosIcon />
                </IconButton>
                {textos.observacao}
            </DialogTitle>
            <DialogContent>
                <TextField
                    multiline
                    minRows={3}
                    id="observacaoPedido"
                    label={textos.observacoesEntrega}
                    margin="normal"
                    variant="outlined"
                    fullWidth
                    value={observacao}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 255 }}
                />
            </DialogContent>
            <DialogActions className={classes.botoes_container}>
                <Button onClick={handleCancel}>Cancelar</Button>
                <Button onClick={handleClose}>Confirmar</Button>
            </DialogActions>
        </Dialog>
    )
}

const ObservacoesPedido = props => {
    const classes = useStyles()

    const { aplicativoDados, cardapio } = useContext(SiteContext)
    const { textos } = useContext(TextosContext)
    const parametros = useParametros()

    const [textoEmail, setTextoEmail] = useState(
        props.emailCliente &&
            !props.emailCliente.includes("c.us") &&
            !props.emailCliente.includes("@cliente_fiel")
            ? props.emailCliente
            : ""
    )
    const [editandoEmail, setEditandoEmail] = useState(false)
    const [editandoCPF, setEditandoCPF] = useState(false)
    const [cpfInput, setCpfInput] = useState(props.cpf)
    const [cpfNaNota, setCpfNaNota] = useState(false)

    const mostrarCPFEmail =
        !(props.isUsuarioPedidoMesa && !aplicativoDados.permiteEscolherPagamentoMesa) &&
        cardapio.formasPagamento &&
        cardapio.formasPagamento.findIndex(forma => forma.id === 91) !== -1
    const mostrarSomenteCPF = !mostrarCPFEmail && parametros.PUBLIC_EXIBIR_CAMPO_CPF === true

    useEffect(() => {
        if (editandoEmail) document.getElementById("campo-edicao-email").focus()
    }, [editandoEmail])

    useEffect(() => {
        if (editandoCPF) document.getElementById("campo-edicao-cpf").focus()
    }, [editandoCPF])

    const textoObservacaoFormatado = props.textoObservacao
        ? props.textoObservacao.length > 60
            ? props.textoObservacao.substring(0, 60) + "..."
            : props.textoObservacao
        : ""

    const toggleCPFNaNota = e => {
        const checked = e.target.checked

        setCpfNaNota(checked)
        props.setCpf(checked ? cpfInput : "")
    }

    const handleChangeCPF = e => {
        const cpfParsed = e.target.value.replace(/\D/g, "").slice(0, 14)
        const length = cpfParsed.length

        let cpfFormatado = cpfParsed

        if (length === 11)
            cpfFormatado = cpfParsed.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")

        if (length === 14)
            cpfFormatado = cpfParsed.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                "$1.$2.$3/$4-$5"
            )

        setCpfInput(cpfFormatado)

        if (cpfNaNota) props.setCpf(cpfFormatado)
    }

    return (
        <div className={classes.containerCpfObservacoes}>
            {mostrarCPFEmail || mostrarSomenteCPF ? (
                <>
                    <div className="container-cpf-email">
                        <div>
                            <div>
                                {editandoCPF ? (
                                    <input
                                        id="campo-edicao-cpf"
                                        value={cpfInput}
                                        onChange={handleChangeCPF}
                                        onBlur={e => {
                                            const cpfParsed = e.target.value.replace(/\D/g, "")

                                            if (
                                                cpfParsed.length &&
                                                !(cpfParsed.length === 11) &&
                                                !(cpfParsed.length === 14)
                                            ) {
                                                setEditandoCPF(false)
                                                setCpfInput("")
                                                props.alertStart("CPF/CNPJ inválido", "warning")
                                                return
                                            }

                                            setEditandoCPF(false)
                                        }}
                                        onKeyUp={e => {
                                            if (e.key === "Enter") {
                                                const cpfParsed = e.target.value.replace(/\D/g, "")

                                                if (
                                                    cpfParsed.length &&
                                                    !(cpfParsed.length === 11) &&
                                                    !(cpfParsed.length === 14)
                                                ) {
                                                    setEditandoCPF(false)
                                                    setCpfInput("")
                                                    props.alertStart("CPF/CNPJ inválido", "warning")
                                                    return
                                                }

                                                setEditandoCPF(false)
                                            }
                                        }}
                                    />
                                ) : (
                                    <span id="campo-display-cpf" data-cpf={cpfInput}>
                                        CPF/CNPJ{cpfInput ? ": " + cpfInput : ""}
                                    </span>
                                )}
                                <Button
                                    size="small"
                                    disabled={editandoCPF}
                                    onClick={() => setEditandoCPF(true)}
                                >
                                    {cpfInput ? textos.alterar : textos.adicionar}
                                </Button>
                            </div>
                            {!mostrarSomenteCPF ? (
                                <div>
                                    {editandoEmail ? (
                                        <input
                                            id="campo-edicao-email"
                                            defaultValue={textoEmail}
                                            onBlur={e => {
                                                const email = e.target.value

                                                if (!e.target.value.length) {
                                                    setEditandoEmail(false)
                                                    return
                                                }

                                                if (email.includes("@") && !email.includes(" ")) {
                                                    setTextoEmail(e.target.value)
                                                    setEditandoEmail(false)
                                                } else
                                                    props.alertStart(
                                                        textos.alertas.emailInvalido,
                                                        "warning"
                                                    )
                                            }}
                                            onKeyUp={e => {
                                                if (e.key === "Enter") {
                                                    const email = e.target.value
                                                    if (
                                                        email.includes("@") &&
                                                        !email.includes(" ")
                                                    ) {
                                                        setTextoEmail(e.target.value)
                                                        setEditandoEmail(false)
                                                    } else
                                                        props.alertStart(
                                                            textos.alertas.emailInvalido,
                                                            "warning"
                                                        )
                                                }
                                            }}
                                        />
                                    ) : (
                                        <span id="campo-display-email" data-email={textoEmail}>
                                            E-mail{textoEmail ? ": " + textoEmail : ""}
                                        </span>
                                    )}
                                    <Button
                                        size="small"
                                        disabled={editandoEmail}
                                        onClick={() => setEditandoEmail(true)}
                                    >
                                        {textoEmail ? textos.alterar : textos.adicionar}
                                    </Button>
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="container-cpf-nota">
                        <Switch color="primary" checked={cpfNaNota} onChange={toggleCPFNaNota} />
                        <Typography variant="body2">CPF/CNPJ na Nota</Typography>
                    </div>
                </>
            ) : null}
            <div className="container-observacoes">
                {props.textoObservacao ? (
                    <>
                        <span>
                            <span className="bold">Observação: </span>
                            <span id="observacaoPedido">{textoObservacaoFormatado}</span>
                        </span>
                        <IconButton size="small" onClick={() => props.setAbrirObservacoes(true)}>
                            <EditIcon />
                        </IconButton>
                    </>
                ) : (
                    <Button size="small" onClick={() => props.setAbrirObservacoes(true)}>
                        {textos.adicionarObservacao}
                    </Button>
                )}
            </div>
            {props.mostrarComerNoLocal ? (
                <div className="container-comer-no-local">
                    <span className="checkbox-comer-no-local">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.isComerNoLocal}
                                    onChange={() => props.setIsComerNoLocal(p => !p)}
                                    id="comer-no-local-checkbox"
                                    color="primary"
                                />
                            }
                            label={textos.vouComerNoLocal}
                        />
                    </span>
                </div>
            ) : null}
        </div>
    )
}

export default function Carrinho(props) {
    const {
        aplicativoDados,

        loading,
        setLoading,

        carrinho,

        setEstabelecimentoAtual,

        realizarLoginMesaObrigatorio,
    } = useContext(SiteContext)

    const { textos } = useContext(TextosContext)

    const { calcularValorTotal, ObterCardapioCalculo } = useContext(CalculosContext)

    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("sm"))
    const { setAbrirDialogLogin, setMensagemDialogLogin } = useContext(LoginDialogContext)

    const {
        visualizacao,
        DialogConfirmacaoinformacoes,
        iphone,
        queroMeCadastrar,
        setQueroMeCadastrar,
        android,
        valorTotalMinimoEntregaCupom,
        classes,
        valorTaxaEntrega,
        setCarrinhoOpen,
        estabelecimentoAtual,
        removerProdutoCarrinho,
        numberoProdutoCarrinho,
        adicionarProdutoCarrinho,
        quantidadeProdutos,
        setAdicionarCupom,
        adicionarCupom,
        fullScreen,
        carrinhoOpen,
        isEntregaNoEndereco,
        usuarioPedidoMesa,
        setInformacoesDoTipoEntrega,
        isRetiradaNoLocal,
        isUsuarioPedidoMesa,
        temEndereco,
        enderecoAtual,
        setTelaRetiradaOuEntrega,
        usuarioLogado,
        isFreteGratisMinimoEntrega,
        alertStart,
        setRodarFuncaoAposIsso,
        setInformacoesPedido,
        qrCodeModal,
        setQrCodeModal,
        informacoesPedido,
        isNumeric,
        mesa,
        setMesa,
        desabilitarInputMesa,
        numeroMesas,
        confirmacaoInformacoes,
        setAbrirMostrarFotoProduto,
        irParaProduto,
        selecioneiRetiradaNoLocal,
        cardapio,
        descontoCardapio,
        removerCupom,
        irParaLogin,
        AdicionarCupom,
        AvatarTipoEntrega,
        EnderecoPedidoMesa,
        QRCode,
        InformacoesDoTipoEntrega,
        AbrirMostrarFotoProduto,
        MostrarFotoProduto,
        TelaRetiradaOuEntrega,
        setEnderecoAtual,
        solicitarNomeAoFinalizar,
        solicitarTelefoneAoFinalizar,
        outrosEstabelecimentosEntregam,
        history,
        openTelaLogin,
        setOpenTelaLogin,
        valorTotalMinimoEntregaPedido,
        valorProdutos,
    } = props

    const parametros = useParametros()

    const continuarSemCadastro =
        !usuarioLogado?.logado &&
        !usuarioPedidoMesa?.logado &&
        aplicativoDados?.permitirContinuarSemCadastro

    const isRetiradaValorMinimo = cardapio?.valorMinimoRetiradaNoLocal > 0 && isRetiradaNoLocal

    const [confirmeiPagamentoOnline, setConfirmeiPagamentoOnline] = useState(false)
    const [abrirAdicionarEndereco, setAbrirAdicionarEndereco] = useState(false)
    const [popUpCep, setPopUpCep] = useState(false)
    const [trocoPronto, setTrocoPronto] = useState(false)
    const [abrirEnderecos, setAbrirEnderecos] = useState(false)
    const [abrirCEP, setAbrirCEP] = useState(false)
    const [cepFoiCadastrado, setCepFoiCadastrado] = useState(true)
    const [abrirNovoEndereco, setAbrirNovoEndereco] = useState(false)
    const [enderecoCadastrado, setEnderecoCadastrado] = useState()

    const [isComerNoLocal, setIsComerNoLocal] = useState(false)

    const [dialogAcao, setDialogAcao] = useState({
        open: false,
        titulo: "titulo",
        descricao: <></>,
        alerta: "alerta",
        primario: {
            texto: "acao1",
            acao: () => {},
        },
        secundario: {
            texto: "acao2",
            acao: () => {},
        },
    })

    const [abrirDialogCadastroCartao, setAbrirDialogCadastroCartao] = useState(false)

    const [abrirObservacoes, setAbrirObservacoes] = useState(false)
    const [textoObservacao, setTextoObservacao] = useState("")

    const [nomePadraoMesa] = useState(parametros.PUBLIC_PADRAO_PEDIDO_MESA)

    const handleCloseDialogAcao = () => setDialogAcao({ ...dialogAcao, open: false })

    const usarGoogleMapsAPI = aplicativoDados.tipoSelecaoEndereco === 1
    const usarMapBoxAPI = aplicativoDados.tipoSelecaoEndereco === 2

    const [openTroco, setOpenTroco] = useState(false)

    const naoPrecisoDeTroco = () => {
        carrinho.pedido.troco = 0
        setOpenTroco(false)

        setTrocoPronto(true)
    }

    const prontoTroco = () => {
        var valorTroco = parseFloat(
            document
                .getElementById("valorTroco")
                .value.replace("R$ ", "")
                .replace(".", "")
                .replace(",", ".")
        )

        if (valorTroco < carrinho.pedido.valorTotal) {
            alertStart(textos.alertas.trocoMenorQueTotal, "warning")
            document.getElementById("valorTroco").focus()
            return false
        } else if (!valorTroco) {
            alertStart(textos.alertas.valorInvalido, "warning")
            document.getElementById("valorTroco").focus()
            return false
        }

        carrinho.pedido.troco = valorTroco
        setOpenTroco(false)

        setTrocoPronto(true)
        return true
    }

    const buscarCardapio = async endereco => {
        console.log(">> buscarCardapio enderecos", endereco)
        setLoading(true)
        try {
            await ObterCardapioCalculo({
                enderecoAtual: endereco,
                estabelecimentoAtual: estabelecimentoAtual,
                usuarioLogado: usuarioLogado,
            })
            if (!estabelecimentoAtual?.id && aplicativoDados?.estabelecimentos?.length > 1) {
                history.push(`/lojas`)
            } else if (
                !estabelecimentoAtual?.id &&
                aplicativoDados?.estabelecimentos?.length == 1
            ) {
                setEstabelecimentoAtual(aplicativoDados.estabelecimentos[0])
                history.push(`/delivery${identificarEstabelecimentoSelecionado(aplicativoDados)}`)
            } else {
                history.push(`/delivery${identificarEstabelecimentoSelecionado(aplicativoDados)}`)
            }
        } catch (error) {
            RegistrarLogErro(error, "buscarCardapio", {
                enderecoAtual: endereco,
                estabelecimentoAtual: estabelecimentoAtual,
                usuarioLogado: usuarioLogado,
            })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
        setLoading(false)
    }

    const valorDesconto =
        (carrinho?.pedido?.valorDesconto ? carrinho?.pedido?.valorDesconto : 0.0) +
        (carrinho?.pedido?.descontoFormaPagamento > 0
            ? carrinho?.pedido?.descontoFormaPagamento
            : 0.0)
    const valorAcrescimo =
        carrinho?.pedido?.descontoFormaPagamento < 0
            ? carrinho?.pedido?.descontoFormaPagamento
            : 0.0

    const taxaEntregaTemporario =
        isRetiradaNoLocal || isFreteGratisMinimoEntrega || carrinho.cupomDesconto?.freteGratis
            ? ""
            : enderecoAtual?.taxaEntrega >= 0
            ? enderecoAtual.taxaEntrega
            : carrinho?.pedido && carrinho?.pedido?.taxaEntrega !== null
            ? carrinho?.pedido?.taxaEntrega
            : ""

    const TaxaEntregaFormatada = () => {
        if (
            carrinho.cupomDesconto?.freteGratis ||
            (carrinho.minimoEntregaGratis &&
                valorProdutos - carrinho.valorDesconto - carrinho.percentualDescontoValor >=
                    carrinho.minimoEntregaGratis)
        )
            return (
                <>
                    <span>{textos.taxaEntrega}: + </span>
                    <span
                        style={{ textDecoration: "line-through", marginRight: "8px", color: "red" }}
                    >
                        {formatarParaDinheiro(valorTaxaEntrega < 0 ? 0 : valorTaxaEntrega)}
                    </span>
                    <br />
                    <span style={{ opacity: 0 }}>{textos.taxaEntrega}: +</span>
                    <span style={{ color: "green" }}>{formatarParaDinheiro(0)}</span>
                    <br />
                </>
            )
        else
            return (
                <>
                    <span>
                        {textos.taxaEntrega}: +
                        {formatarParaDinheiro(valorTaxaEntrega < 0 ? 0 : valorTaxaEntrega)}
                    </span>
                    <br />
                </>
            )
    }

    const enviarPedidoHandler = () => {
        try {
            if (
                cardapio?.mensagemConfirmacaoPagamentoOnline &&
                carrinho?.pedido?.formaPagamento?.id === 40 &&
                confirmeiPagamentoOnline === false
            ) {
                alertStart(
                    "É necessário que você clique no quadradinho para confirmar mensagem sobre pagamento online.",
                    "error"
                )
                return false
            }
            if (carrinho.pedido.formaPagamento?.id === 1 && !trocoPronto) {
                setOpenTroco(true)
            } else {
                confirmacaoInformacoes()
            }
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "enviarPedidoHandler", carrinho)
        }
    }

    const getNomeMesa = () => {
        if (nomePadraoMesa) return nomePadraoMesa

        if (isNumeric(mesa)) return `${textos.mesa} ${mesa}`

        if (mesa === "--") return textos.selecioneSuaMesa

        if (mesa) return mesa // Quando mesa é texto, não número (Ex.: Buffet)

        return textos.mesa
    }

    const mostrarComerNoLocal = isRetiradaNoLocal && aplicativoDados.permiteConsumoNoLocal

    return (
        <>
            {/* <DialogCadastroPorMensagem abrirDialogCadastroIzza={false} enviarPorSMS={()=>{}}/> */}
            <DialogAcao dialogAcao={dialogAcao} handleClose={handleCloseDialogAcao} />

            {aplicativoDados?.permitirContinuarSemCadastro &&
                !usuarioLogado?.logado &&
                !usuarioPedidoMesa?.logado && (
                    <CadastroEndereco
                        setInformacoesPedido={setInformacoesPedido}
                        DialogConfirmacaoinformacoes={DialogConfirmacaoinformacoes}
                        telaDeCardapio={true}
                        setInformacoesDoTipoEntrega={setInformacoesDoTipoEntrega}
                        estabelecimentoAtual={estabelecimentoAtual}
                        setLoading={setLoading}
                        alertStart={alertStart}
                        aplicativoDados={aplicativoDados}
                        enderecoAtual={enderecoAtual}
                        retirarNoLocal={isRetiradaNoLocal}
                        usuarioLogado={usuarioLogado}
                        setEnderecoAtual={setEnderecoAtual}
                        abrirAdicionarEndereco={abrirAdicionarEndereco}
                        setAbrirAdicionarEndereco={setAbrirAdicionarEndereco}
                        setPopUpCep={setPopUpCep}
                        popUpCep={popUpCep}
                        continuarSemCadastro={continuarSemCadastro}
                    />
                )}

            {carrinho.pedido?.itens?.length > 0 && !visualizacao && (
                <Fab
                    variant="extended"
                    size="small"
                    color="primary"
                    aria-label="add"
                    style={iphone || android ? undefined : { padding: "25px" }}
                    onClick={() => {
                        setTrocoPronto(false)
                        setCarrinhoOpen(true)
                    }}
                    className={usuarioPedidoMesa ? classes.fixedMesa : classes.fixed}
                    id="botaoCarrinho"
                    style={{ "background-color": aplicativoDados.corSiteBarraFinalizar }}
                >
                    <ShoppingBasketIcon className={classes.extendedIcon} />
                    {/* carrinho.pedido?.itens?.length + " " */}
                    {/* { carrinho.pedido?.itens?.length > 1 ? "Produtos" : "Produto" } */}
                    {textos.finalizarPedido}
                    <span
                        className="valorFinalizarPedido"
                        style={{ color: aplicativoDados.corSiteBarraFinalizar }}
                    >
                        {estabelecimentoAtual.somarQtdItens == true
                            ? quantidadeProdutos() //carrinho.pedido?.itens.length
                            : formatarParaDinheiro(carrinho.pedido?.valorTotal)}
                    </span>
                </Fab>
            )}

            {carrinho.pedido?.itens?.length > 0 && (
                <Dialog open={AdicionarCupom} aria-labelledby="adicionarCupom">
                    <img src={aplicativoDados.urlLogo} className="imgModal" />

                    <DialogTitle id="informarcoesImportantes">
                        <IconButton
                            className="setaVoltarModal"
                            onClick={() => {
                                setAdicionarCupom(false)
                            }}
                        >
                            <ArrowForwardIosIcon />
                        </IconButton>
                        {textos.adicionarCupom}
                    </DialogTitle>

                    <DialogContent>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            autoFocus
                            id="codigoAddCupom"
                            label={textos.codigoCupom}
                            name="codigoAddCupom"
                        />
                    </DialogContent>
                    <DialogActions style={{ justifyContent: "center" }}>
                        {/* <Button onClick={() => {
                    setAdicionarCupom(false)
                }} style={{"color": "#dc3545"}}>
                    Cancelar
                </Button> */}

                        <Button
                            onClick={adicionarCupom}
                            fullWidth
                            style={{ color: "white", backgroundColor: "#28a745" }}
                        >
                            {textos.adicionar}
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            {carrinho.pedido?.itens?.length > 0 ? (
                <>
                    <Dialog
                        // fullScreen={false}
                        fullScreen={fullScreen}
                        style={{ zIndex: 1300 }}
                        fullWidth={true}
                        maxWidth={"md"}
                        open={carrinhoOpen}
                        onClose={() => {
                            setCarrinhoOpen(false)
                        }}
                        aria-labelledby="Carrinho-de-Pedidos"
                    >
                        {!fullScreen ? (
                            <img src={aplicativoDados.urlLogo} className="imgModal" />
                        ) : null}

                        <DialogTitle id="Carrinho-de-Pedidos">
                            <IconButton
                                className="setaVoltarModal"
                                onClick={() => {
                                    setCarrinhoOpen(false)
                                }}
                            >
                                <ArrowForwardIosIcon />
                            </IconButton>
                            {textos.pedido}
                        </DialogTitle>

                        <DialogContent>
                            <List
                                component="div"
                                aria-labelledby="nested-list-subheader"
                                className={classes.rootCarrinho}
                            >
                                {isEntregaNoEndereco === false && temEndereco && (
                                    <>
                                        <AlertFixo style={{ marginBottom: "1em" }} severity="error">
                                            Essa loja não entrega no seu endereço
                                            <b>
                                                {enderecoAtual.logradouro}, {enderecoAtual.numero} -
                                                {enderecoAtual.bairro}
                                            </b>
                                            <Button
                                                onClick={() => {
                                                    setAbrirEnderecos(true)
                                                }}
                                                style={{ padding: "0px", fontSize: "80%" }}
                                            >
                                                Trocar
                                            </Button>
                                        </AlertFixo>

                                        {outrosEstabelecimentosEntregam.length ? (
                                            <AlertFixo
                                                style={{ margin: "0.5em 0" }}
                                                className="campoDeUmAlert"
                                                onClick={() => {}}
                                                severity="warning"
                                            >
                                                Existe outro estabelecimento que entrega no seu
                                                endereço.
                                                <Button
                                                    style={{ padding: "0px", fontSize: "80%" }}
                                                    onClick={() => {
                                                        history.push("/lojas")
                                                    }}
                                                >
                                                    trocar
                                                </Button>
                                            </AlertFixo>
                                        ) : null}
                                    </>
                                )}

                                {/* {(!isUsuarioPedidoMesa && usuarioLogado?.cliente?.id) && */}
                                {!isUsuarioPedidoMesa && (
                                    <span>
                                        {!isUsuarioPedidoMesa &&
                                            !isRetiradaNoLocal &&
                                            isEntregaNoEndereco &&
                                            carrinho.minimoEntregaGratis > 0 &&
                                            carrinho.minimoEntregaGratis < 999 && (
                                                <AlertFixo
                                                    style={{ marginBottom: "1em" }}
                                                    severity={
                                                        isFreteGratisMinimoEntrega
                                                            ? "success"
                                                            : "warning"
                                                    }
                                                    className="campoDeUmAlert"
                                                >
                                                    Frete Grátis acima de{" "}
                                                    <b>
                                                        {formatarParaDinheiro(
                                                            carrinho.minimoEntregaGratis
                                                        )}
                                                    </b>{" "}
                                                    no total dos produtos.
                                                </AlertFixo>
                                            )}

                                        {
                                            /* ========== ALERTA MINIMO PARA REALIZAR PEDIDO ============ */
                                            isRetiradaValorMinimo &&
                                            valorTotalMinimoEntregaPedido <
                                                carrinho.valorMinimoRetiradaNoLocal ? (
                                                <AlertFixo
                                                    severity={
                                                        valorTotalMinimoEntregaPedido >
                                                        carrinho.valorMinimoRetiradaNoLocal
                                                            ? "success"
                                                            : "warning"
                                                    }
                                                    className="campoDeUmAlert"
                                                >
                                                    O valor mínimo do pedido para retirada é de
                                                    <b>
                                                        {formatarParaDinheiro(
                                                            carrinho.valorMinimoRetiradaNoLocal
                                                        )}
                                                    </b>
                                                </AlertFixo>
                                            ) : !isRetiradaValorMinimo &&
                                              carrinho.valorMinimoPedido > 0 &&
                                              valorTotalMinimoEntregaPedido <
                                                  carrinho.valorMinimoPedido ? null : null
                                            //Ao voltar, será avaliado o valor mínimo do pedido
                                            //? <AlertFixo severity={valorTotalMinimoEntregaPedido > carrinho.valorMinimoPedido ? "success" : "warning"} className="campoDeUmAlert">O valor mínimo do pedido é de <b>{formatarParaDinheiro(carrinho.valorMinimoPedido)} </b></AlertFixo>
                                        }

                                        {
                                            /* ========== ALERTA MINIMO PARA REALIZAR PEDIDO COM CUPOM ============ */
                                            cardapio.cupomDesconto &&
                                                cardapio.cupomDesconto.valorPedidoMinimo > 0 &&
                                                valorTotalMinimoEntregaCupom <
                                                    cardapio.cupomDesconto.valorPedidoMinimo && (
                                                    <AlertFixo
                                                        style={{ margin: "5px 0" }}
                                                        severity={
                                                            carrinho.pedido.valorTotal >
                                                            cardapio.cupomDesconto.valorPedidoMinimo
                                                                ? "success"
                                                                : "warning"
                                                        }
                                                        className="campoDeUmAlert"
                                                    >
                                                        O valor mínimo do pedido com cupom (
                                                        <b>{cardapio.cupomDesconto.codigoCupom}</b>)
                                                        é de
                                                        <b>
                                                            {formatarParaDinheiro(
                                                                cardapio.cupomDesconto
                                                                    .valorPedidoMinimo
                                                            )}
                                                        </b>
                                                    </AlertFixo>
                                                )
                                        }

                                        {(isRetiradaNoLocal ||
                                            (isEntregaNoEndereco && temEndereco)) && (
                                            <>
                                                <ListItem
                                                    button
                                                    style={{
                                                        paddingLeft: "0px",
                                                        paddingRight: "0px",
                                                    }}
                                                    onClick={() => {
                                                        setRodarFuncaoAposIsso("")
                                                        continuarSemCadastro
                                                            ? estabelecimentoAtual.permiteRetiradaBalcao
                                                                ? setTelaRetiradaOuEntrega(true)
                                                                : setAbrirCEP(true)
                                                            : setAbrirEnderecos(true)
                                                    }}
                                                >
                                                    <ListItemAvatar>
                                                        <AvatarTipoEntrega
                                                            color={aplicativoDados.corSitePrimaria}
                                                            retirada={isRetiradaNoLocal}
                                                        />
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={
                                                            isRetiradaNoLocal
                                                                ? `Retirada${
                                                                      estabelecimentoAtual.tempoRetiradaLocal
                                                                          ? ` - ${estabelecimentoAtual.tempoRetiradaLocal}`
                                                                          : ""
                                                                  }`
                                                                : isEntregaNoEndereco
                                                                ? `Entrega${
                                                                      estabelecimentoAtual.tempoEntregaTexto
                                                                          ? ` - ${estabelecimentoAtual.tempoEntregaTexto}`
                                                                          : ""
                                                                  }`
                                                                : null
                                                        }
                                                    />
                                                    <ListItemText
                                                        primary={
                                                            !!taxaEntregaTemporario ||
                                                            taxaEntregaTemporario === 0
                                                                ? formatarParaDinheiro(
                                                                      taxaEntregaTemporario
                                                                  )
                                                                : ""
                                                        }
                                                        className="carrinho-produto-valor"
                                                        secondary={
                                                            <Button
                                                                style={{
                                                                    padding: "0px",
                                                                    float: "right",
                                                                    fontSize: "80%",
                                                                }}
                                                            >
                                                                Trocar
                                                            </Button>
                                                        }
                                                    />
                                                </ListItem>
                                                <List component="div" disablePadding>
                                                    <ListItem
                                                        className={classes.nested}
                                                        style={{ paddingTop: "0" }}
                                                    >
                                                        <ListItemText
                                                            secondary={
                                                                isRetiradaNoLocal
                                                                    ? `${estabelecimentoAtual?.nome}: ${estabelecimentoAtual?.endereco} - ${estabelecimentoAtual?.telefone}`
                                                                    : `${enderecoAtual.logradouro}, ${enderecoAtual.numero} - ${enderecoAtual.bairro}`
                                                            }
                                                        />
                                                    </ListItem>
                                                </List>
                                                <Divider />
                                            </>
                                        )}
                                    </span>
                                )}

                                {(cardapio.percentualDesconto || cardapio.valorDesconto) &&
                                cardapio.informacao &&
                                cardapio.idCartelaCompleta ? (
                                    <span>
                                        <ListItem
                                            // button
                                            style={{ paddingLeft: "0px", paddingRight: "0px" }}
                                        >
                                            <ListItemAvatar>
                                                <Avatar style={{ background: "#f9f9f9" }}>
                                                    <FavoriteIcon
                                                        style={{
                                                            color: aplicativoDados.corSitePrimaria,
                                                        }}
                                                    />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={
                                                    cardapio.idCartelaCompleta
                                                        ? "Fidelidade"
                                                        : "Desconto"
                                                }
                                            />
                                            <ListItemText
                                                primary={
                                                    cardapio.idCartelaCompleta &&
                                                    (cardapio.percentualDesconto ||
                                                        carrinho.percentualDesconto)
                                                        ? `-${
                                                              cardapio.percentualDesconto ||
                                                              carrinho.percentualDesconto
                                                          }%`
                                                        : formatarParaDinheiro(-descontoCardapio)
                                                }
                                                className="carrinho-produto-valor-negativo"
                                                secondary={
                                                    <Button
                                                        onClick={removerCupom}
                                                        style={{
                                                            padding: "0px",
                                                            float: "right",
                                                            fontSize:
                                                                "80%" /*,"color": `${aplicativoDados.corSitePrimaria}` */,
                                                        }}
                                                    >
                                                        Não Usar
                                                    </Button>
                                                }
                                            />
                                        </ListItem>
                                        <List component="div" disablePadding>
                                            <ListItem
                                                className={classes.nested}
                                                style={{ paddingTop: "0" }}
                                            >
                                                <ListItemText secondary={cardapio.informacao} />
                                            </ListItem>
                                        </List>
                                        <Divider />
                                    </span>
                                ) : (cardapio.percentualDesconto || cardapio.valorDesconto) &&
                                  !cardapio.cupomDesconto ? (
                                    <span>
                                        <ListItem
                                            style={{ paddingLeft: "0px", paddingRight: "0px" }}
                                        >
                                            <ListItemAvatar>
                                                <Avatar style={{ background: "#f9f9f9" }}>
                                                    <FavoriteIcon
                                                        style={{
                                                            color: aplicativoDados.corSitePrimaria,
                                                        }}
                                                    />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText primary={"Desconto"} />
                                            <ListItemText
                                                primary={
                                                    cardapio.percentualDesconto
                                                        ? `-${cardapio.percentualDesconto}%`
                                                        : formatarParaDinheiro(
                                                              -cardapio.valorDesconto
                                                          )
                                                }
                                                className="carrinho-produto-valor-negativo"
                                            />
                                        </ListItem>
                                        <List component="div" disablePadding>
                                            <ListItem
                                                className={classes.nested}
                                                style={{ paddingTop: "0" }}
                                            >
                                                <ListItemText
                                                    secondary={"Você ganhou um desconto"}
                                                />
                                            </ListItem>
                                        </List>
                                        <Divider />
                                    </span>
                                ) : null}

                                {carrinho.cupomDesconto ? (
                                    <span>
                                        <ListItem
                                            // button
                                            style={{ paddingLeft: "0px", paddingRight: "0px" }}
                                        >
                                            <ListItemAvatar>
                                                <Avatar style={{ background: "#f9f9f9" }}>
                                                    <ConfirmationNumberIcon
                                                        style={{
                                                            color: aplicativoDados.corSitePrimaria,
                                                        }}
                                                    />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={carrinho.cupomDesconto.codigoCupom}
                                            />
                                            <ListItemText
                                                primary={
                                                    descontoCardapio <= 0
                                                        ? ""
                                                        : formatarParaDinheiro(-descontoCardapio)
                                                }
                                                className="carrinho-produto-valor-negativo"
                                                secondary={
                                                    <Button
                                                        onClick={removerCupom}
                                                        style={{
                                                            padding: "0px",
                                                            float: "right",
                                                            fontSize:
                                                                "80%" /*,"color": `${aplicativoDados.corSitePrimaria}` */,
                                                        }}
                                                    >
                                                        Remover
                                                    </Button>
                                                }
                                            />
                                        </ListItem>
                                        <List component="div" disablePadding>
                                            <ListItem
                                                className={classes.nested}
                                                style={{ paddingTop: "0" }}
                                            >
                                                <ListItemText
                                                    secondary={
                                                        carrinho.cupomDesconto.mensagem
                                                            ? carrinho.cupomDesconto.mensagem
                                                            : `Cupom de desconto ${
                                                                  carrinho.cupomDesconto.codigoCupom
                                                              } ${
                                                                  carrinho.cupomDesconto.freteGratis
                                                                      ? "com frete grátis"
                                                                      : ""
                                                              } ${
                                                                  carrinho.cupomDesconto
                                                                      .valorPedidoMinimo
                                                                      ? ` - Valor Minímo do Pedido é de ${formatarParaDinheiro(
                                                                            carrinho.cupomDesconto
                                                                                .valorPedidoMinimo
                                                                        )}`
                                                                      : ""
                                                              }`
                                                    }
                                                />
                                            </ListItem>
                                        </List>
                                        <Divider />
                                    </span>
                                ) : (
                                    !usuarioPedidoMesa?.logado &&
                                    !(carrinho.percentualDesconto || carrinho.valorDesconto) && (
                                        <span>
                                            <ListItem
                                                button
                                                style={{ paddingLeft: "0px", paddingRight: "0px" }}
                                                onClick={() => {
                                                    if (!usuarioLogado?.logado) {
                                                        setDialogAcao({
                                                            open: true,
                                                            titulo: "Você precisa de acesso",
                                                            alerta: null,
                                                            descricao:
                                                                "Vejo que você está tentando adicionar um cupom, porém não identificamos seu acesso.",
                                                            secundario: {
                                                                texto: "Voltar",
                                                                acao: () => {},
                                                            },
                                                            primario: {
                                                                texto: "Acessar",
                                                                acao: () => {
                                                                    irParaLogin()
                                                                },
                                                            },
                                                        })
                                                    } else {
                                                        //modal de digitar cupom
                                                        setAdicionarCupom(true)
                                                    }
                                                }}
                                            >
                                                <ListItemAvatar>
                                                    <Avatar style={{ background: "#f9f9f9" }}>
                                                        <ConfirmationNumberIcon
                                                            style={{
                                                                color: aplicativoDados.corSitePrimaria,
                                                            }}
                                                        />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary={textos.adicionarCupom} />
                                            </ListItem>
                                            <Divider />
                                        </span>
                                    )
                                )}

                                {carrinho?.pedido &&
                                    carrinho.pedido?.formaPagamento &&
                                    carrinho.pedido.formaPagamento?.desconto && (
                                        <span>
                                            <ListItem
                                                style={{ paddingLeft: "0px", paddingRight: "0px" }}
                                            >
                                                <ListItemAvatar>
                                                    <Avatar style={{ background: "#f9f9f9" }}>
                                                        <PaymentIcon
                                                            style={{
                                                                color: aplicativoDados.corSitePrimaria,
                                                            }}
                                                        />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={`${
                                                        carrinho.pedido.formaPagamento.desconto > 0
                                                            ? "Desconto"
                                                            : "Acrescimo"
                                                    } em ${
                                                        carrinho.pedido.formaPagamento.descricao
                                                    }`}
                                                />
                                                <ListItemText
                                                    primary={
                                                        carrinho.pedido.formaPagamento.desconto >= 0
                                                            ? `- ${Math.abs(
                                                                  carrinho.pedido.formaPagamento
                                                                      .desconto
                                                              )} %`
                                                            : ` ${Math.abs(
                                                                  carrinho.pedido.formaPagamento
                                                                      .desconto
                                                              )} %`
                                                    }
                                                    className={
                                                        carrinho.pedido.formaPagamento.desconto > 0
                                                            ? "carrinho-produto-valor-negativo"
                                                            : "carrinho-produto-valor-positivo"
                                                    }
                                                />
                                            </ListItem>
                                            <Divider />
                                        </span>
                                    )}

                                {carrinho.pedido?.itens.map((item, index) => (
                                    <div key={index} style={{ position: "relative" }}>
                                        <ListItem
                                            style={{ paddingLeft: "0px", paddingRight: "0px" }}
                                            // onClick={() => {
                                            //     setRemoveItemSelecionado(index)
                                            //     setRemoveItem(true)
                                            // }}
                                        >
                                            <ListItemAvatar
                                                style={{
                                                    minWidth: "0px",
                                                }}
                                            >
                                                {item.produto.urlImagem ? (
                                                    <Avatar
                                                        style={{
                                                            backgroundImage: `url(${item.produto.urlImagem})`,
                                                            backgroundSize: "cover",
                                                        }}
                                                    >
                                                        <> </>
                                                    </Avatar>
                                                ) : (
                                                    <Avatar
                                                        className={"opacity05"}
                                                        style={{
                                                            backgroundImage: `url(${
                                                                item.produto.produtoExibicao
                                                                    ? Megafone
                                                                    : /**Prato */ Comida
                                                            })`,
                                                            backgroundSize: "cover",
                                                            backgroundColor: "white",
                                                        }}
                                                    >
                                                        <> </>
                                                    </Avatar>
                                                )}
                                            </ListItemAvatar>
                                            <Row
                                                style={{
                                                    paddingLeft: "10px",
                                                    margin: "0",
                                                }}
                                            >
                                                <ListItemText
                                                    primary={
                                                        item.quantidade + "x " + item.produto.nome
                                                    }
                                                />

                                                <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={12}
                                                    className="colOpcaoAdicional"
                                                    style={{
                                                        textAlign: "left",
                                                        padding: "0",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: mobile
                                                            ? "space-between"
                                                            : "start",
                                                    }}
                                                >
                                                    <ButtonGroup>
                                                        <Button
                                                            size="small"
                                                            aria-label="reduce"
                                                            onClick={() => {
                                                                removerProdutoCarrinho(item.produto)
                                                            }}
                                                            disabled={
                                                                item.quantidade == 0 ? true : false
                                                            }
                                                            style={
                                                                item.quantidade == 0
                                                                    ? {
                                                                          background: "#7e7e7e",
                                                                          color: "white",
                                                                      }
                                                                    : {
                                                                          background: "#dc354596",
                                                                          color: "white",
                                                                      }
                                                            }
                                                        >
                                                            <RemoveIcon fontSize="small" />
                                                        </Button>
                                                        <input
                                                            style={{
                                                                width: "25px",
                                                                textAlign: "center",
                                                                border: "1px solid rgba(0, 0, 0, 0.12)",
                                                            }}
                                                            type={"number"}
                                                            disabled={
                                                                item.produto
                                                                    .qntMultiplicativaProdutos > 1
                                                                    ? true
                                                                    : false
                                                            }
                                                            onChange={e => {
                                                                const number = parseInt(
                                                                    e.target.value.replace(
                                                                        /([^\d])+/gim,
                                                                        ""
                                                                    )
                                                                )
                                                                console.log("number", number)
                                                                if (number > 0) {
                                                                    e.target.value = number
                                                                }
                                                                numberoProdutoCarrinho(
                                                                    item.produto,
                                                                    number
                                                                )
                                                            }}
                                                            value={
                                                                !(
                                                                    item.quantidade == NaN ||
                                                                    item.quantidade == undefined
                                                                )
                                                                    ? item.quantidade
                                                                    : 0
                                                            }
                                                        />

                                                        {aplicativoDados.permitirIncrementarQuantidadeProduto ? (
                                                            <Button
                                                                aria-label="increase"
                                                                size="small"
                                                                disabled={
                                                                    item.quantidade ==
                                                                    item.produto.qntMaximaProdutos
                                                                        ? true
                                                                        : false
                                                                }
                                                                style={
                                                                    item.quantidade ==
                                                                    item.produto.qntMaximaProdutos
                                                                        ? {
                                                                              background: "#7e7e7e",
                                                                              color: "white",
                                                                          }
                                                                        : {
                                                                              background:
                                                                                  "#28a74596",
                                                                              color: "white",
                                                                          }
                                                                }
                                                                onClick={() => {
                                                                    adicionarProdutoCarrinho(
                                                                        item.produto
                                                                    )
                                                                }}
                                                            >
                                                                <AddIcon fontSize="small" />
                                                            </Button>
                                                        ) : null}
                                                    </ButtonGroup>
                                                    <Typography
                                                        style={
                                                            !mobile
                                                                ? { marginLeft: "1em" }
                                                                : undefined
                                                        }
                                                        className="carrinho-produto-valor-positivo"
                                                    >
                                                        {formatarParaDinheiro(
                                                            item.valorProdutoHistorico
                                                        )}
                                                    </Typography>
                                                </Col>
                                            </Row>
                                        </ListItem>

                                        {item.produto.promocional &&
                                        cardapio.percentualDesconto &&
                                        !cardapio.valorDesconto ? (
                                            <List key={index} component="div" disablePadding>
                                                <ListItem
                                                    className={classes.nested}
                                                    style={{ paddingTop: "0" }}
                                                >
                                                    <p className="promocionalElement">
                                                        É promocional, então não recebe descontos
                                                        percentuais.
                                                    </p>
                                                </ListItem>
                                            </List>
                                        ) : null}

                                        {!!item.itensOpcaoProduto.length &&
                                            item.itensOpcaoProduto.map((adicional, index) => (
                                                <List key={index} component="div" disablePadding>
                                                    <ListItem
                                                        className={classes.nested}
                                                        style={{ paddingTop: "0" }}
                                                    >
                                                        <ListItemText
                                                            secondary={`${adicional.quantidade}x ${
                                                                adicional.opcaoProduto.nome
                                                            } - ${formatarParaDinheiro(
                                                                adicional.valorHistorico
                                                            )}`}
                                                        />
                                                    </ListItem>
                                                </List>
                                            ))}

                                        <Divider />
                                    </div>
                                ))}
                            </List>
                        </DialogContent>

                        <DialogActions style={{ flexDirection: "column" }}>
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={() => {
                                    // BOTÃO AVANÇAR
                                    if (aplicativoDados.clienteFielStart) {
                                        setAbrirNovoEndereco(true)
                                    } else {
                                        const estabelecimentoOffline =
                                            !estabelecimentoAtual.online &&
                                            !usuarioPedidoMesa?.logado

                                        if (estabelecimentoOffline) {
                                            alertStart(
                                                "Estamos fechados no momento. Tente novamente mais tarde!",
                                                "warning"
                                            )
                                        } else if (
                                            !estabelecimentoOffline &&
                                            estabelecimentoAtual.pausado
                                        ) {
                                            alertStart(
                                                "Estamos abertos, porém pausados nesse momento. Tente novamente mais tarde!",
                                                "warning"
                                            )
                                        } else if (isEntregaNoEndereco === false && temEndereco) {
                                            alertStart(
                                                "Não entregamos no seu endereço atualmente.",
                                                "warning"
                                            )
                                        } else if (
                                            isRetiradaValorMinimo &&
                                            valorTotalMinimoEntregaPedido <
                                                carrinho.valorMinimoRetiradaNoLocal &&
                                            !usuarioPedidoMesa?.logado
                                        ) {
                                            setDialogAcao({
                                                open: true,
                                                titulo: "Estamos em dúvida",
                                                alerta: (
                                                    <AlertFixo
                                                        style={{ marginBottom: "10px" }}
                                                        severity={"warning"}
                                                        className="campoDeUmAlert"
                                                    >
                                                        O valor mínimo do pedido para retirada é de
                                                        <b>
                                                            {formatarParaDinheiro(
                                                                carrinho.valorMinimoRetiradaNoLocal
                                                            )}
                                                        </b>
                                                    </AlertFixo>
                                                ),
                                                descricao:
                                                    "Vejo que você está tentando realizar um pedido com o valor abaixo do pedido mínimo para retirada, clique em Adicionar Produto.",
                                                secundario: {
                                                    texto: "Voltar",
                                                    acao: () => {},
                                                },
                                                primario: {
                                                    texto: "Adicionar Produto",
                                                    acao: () => setCarrinhoOpen(false),
                                                },
                                            })
                                            //Ao descomentar, será avaliado um popup com o valor mínimo do pedido
                                            // } else if (!isRetiradaValorMinimo && valorTotalMinimoEntregaPedido < carrinho.valorMinimoPedido && !usuarioPedidoMesa?.logado) {
                                            //     setDialogAcao({
                                            //         open: true,
                                            //         titulo: 'Estamos em dúvida',
                                            //         alerta: <AlertFixo style={{ "marginBottom": "10px" }} severity={"warning"} className="campoDeUmAlert">O valor mínimo para pedido é de <b>{formatarParaDinheiro(carrinho.valorMinimoPedido)}</b></AlertFixo>,
                                            //         descricao: 'Vejo que você está tentando realizar um pedido com o valor abaixo do pedido mínimo, clique em Adicionar Produto.',
                                            //         secundario: {
                                            //             texto: 'Voltar',
                                            //             acao: () => { }
                                            //         },
                                            //         primario: {
                                            //             texto: 'Adicionar Produto',
                                            //             acao: () => setCarrinhoOpen(false)
                                            //         },
                                            //     })
                                        } else if (
                                            cardapio.cupomDesconto &&
                                            cardapio.cupomDesconto.valorPedidoMinimo >
                                                valorTotalMinimoEntregaCupom
                                        ) {
                                            // alertStart(`O valor do pedido para usar esse cupom é de ${formatarParaDinheiro(cardapio.cupomDesconto.valorPedidoMinimo)}. Adicione mais produtos ou remova o cupom.`, "warning")
                                            setDialogAcao({
                                                open: true,
                                                titulo: "Estamos em dúvida",

                                                alerta: (
                                                    <AlertFixo
                                                        style={{ marginBottom: "10px" }}
                                                        severity={
                                                            valorTotalMinimoEntregaCupom >
                                                            cardapio.cupomDesconto.valorPedidoMinimo
                                                                ? "success"
                                                                : "warning"
                                                        }
                                                        className="campoDeUmAlert"
                                                    >
                                                        O valor mínimo do pedido com cupom (
                                                        <b>{cardapio.cupomDesconto.codigoCupom}</b>)
                                                        é de
                                                        <b>
                                                            {formatarParaDinheiro(
                                                                cardapio.cupomDesconto
                                                                    .valorPedidoMinimo
                                                            )}
                                                        </b>
                                                    </AlertFixo>
                                                ),
                                                descricao:
                                                    "Vejo que você possui um cupom que não pode ser usado devido ao valor do seu pedido. Você deseja confirmar e remover o cupom ou adicionar mais produtos?",
                                                secundario: {
                                                    texto: "Remover Cupom",
                                                    acao: () => {
                                                        handleCloseDialogAcao()
                                                        removerCupom()
                                                    },
                                                },
                                                primario: {
                                                    texto: "Adicionar Produto",
                                                    acao: () => {
                                                        setCarrinhoOpen(false)
                                                        handleCloseDialogAcao()
                                                    },
                                                },
                                            })
                                        } else {
                                            if (usuarioPedidoMesa?.logado) {
                                                EnderecoPedidoMesa()
                                                DialogConfirmacaoinformacoes(true)
                                                return
                                            }

                                            if (!aplicativoDados?.permitirDesconectarMesa) {
                                                try {
                                                    RegistrarLogErro({}, "mesaDesconectada", {
                                                        estabelecimentoAtual,
                                                        carrinho,
                                                        aplicativoDados,
                                                    })

                                                    const params = new URLSearchParams(
                                                        window.location.search
                                                    )

                                                    const hasSettedMesa =
                                                        params.get("mesa") ??
                                                        window.getCookie("mesa-salva")

                                                    const mesa = hasSettedMesa.length
                                                        ? hasSettedMesa
                                                        : "--"

                                                    realizarLoginMesaObrigatorio(
                                                        aplicativoDados,
                                                        estabelecimentoAtual,
                                                        mesa
                                                    )
                                                } catch (error) {
                                                    RegistrarLogErro(
                                                        error,
                                                        "mesaDesconectada - tryCatch",
                                                        {
                                                            estabelecimentoAtual,
                                                            carrinho,
                                                            aplicativoDados,
                                                        }
                                                    )
                                                }
                                            }

                                            if (!usuarioLogado?.logado) {
                                                if (
                                                    !aplicativoDados?.permitirContinuarSemCadastro
                                                ) {
                                                    setAbrirDialogLogin(true)
                                                    setMensagemDialogLogin(
                                                        "Precisamos verificar sua identidade - Por favor preencha com o seu telefone:"
                                                    )
                                                    setInformacoesDoTipoEntrega(false)
                                                    return
                                                }

                                                if (!isRetiradaNoLocal && !temEndereco) {
                                                    if (
                                                        usarGoogleMapsAPI ||
                                                        !(
                                                            estabelecimentoAtual.permiteRetiradaBalcao ||
                                                            aplicativoDados.permiteRetiradaBalcao
                                                        )
                                                    ) {
                                                        setAbrirCEP(true)
                                                    } else {
                                                        setTelaRetiradaOuEntrega(true)
                                                    }
                                                } else {
                                                    DialogConfirmacaoinformacoes(true)
                                                }

                                                return
                                            }

                                            if (isRetiradaNoLocal || temEndereco) {
                                                DialogConfirmacaoinformacoes(true)
                                            } else {
                                                setAbrirEnderecos(true)
                                            }
                                        }
                                    }
                                }}
                                size="large"
                                style={
                                    isEntregaNoEndereco === false && temEndereco
                                        ? {}
                                        : { background: "#28a745", color: "white" }
                                }
                            >
                                {textos.avancar}
                                {isEntregaNoEndereco === false && temEndereco ? null : (
                                    <span className="valorFinalizarPedido">
                                        {formatarParaDinheiro(
                                            carrinho.pedido.valorTotal
                                                ? carrinho.pedido.valorTotal
                                                : 0.0
                                        )}
                                    </span>
                                )}
                            </Button>

                            <Button
                                size="large"
                                fullWidth
                                onClick={() => {
                                    setCarrinhoOpen(false)
                                }}
                                // style={{"color": "#dc3545"}}
                            >
                                {textos.adicionarMaisProdutos}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {usuarioPedidoMesa?.logado && estabelecimentoAtual.solicitarComanda && (
                        <Dialog
                            fullScreen={fullScreen}
                            fullWidth={true}
                            maxWidth={"md"}
                            open={qrCodeModal}
                            aria-labelledby="qrCodeComanda"
                        >
                            {!fullScreen ? (
                                <img src={aplicativoDados.urlLogo} className="imgModal" />
                            ) : null}

                            <DialogTitle id="qrCodeComanda">
                                {"Leia o QRCode na COMANDA"}
                            </DialogTitle>
                            <DialogContent>{qrCodeModal ? <QRCode /> : null}</DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={() => {
                                        setQrCodeModal(false)
                                    }}
                                >
                                    Cancelar
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}

                    <Dialog
                        fullScreen={fullScreen}
                        // fullScreen={true}
                        fullWidth={true}
                        maxWidth={"md"}
                        open={informacoesPedido}
                        onClose={() => {
                            DialogConfirmacaoinformacoes(false)
                        }}
                        aria-labelledby="responsive-dialog-informacoes-nome-pedido"
                    >
                        {!fullScreen ? (
                            <img src={aplicativoDados.urlLogo} className="imgModal" />
                        ) : null}

                        <DialogTitle id="responsive-dialog-informacoes-nome-pedido">
                            <IconButton
                                className="setaVoltarModal"
                                onClick={() => {
                                    DialogConfirmacaoinformacoes(false)
                                }}
                            >
                                <ArrowForwardIosIcon />
                            </IconButton>
                            {textos.confirmacaoDados}
                        </DialogTitle>
                        <DialogContent>
                            <div style={{ textAlign: "center" }}>
                                {!isUsuarioPedidoMesa && (
                                    <Button
                                        onClick={() => {
                                            if (continuarSemCadastro === true) {
                                                if (
                                                    usarGoogleMapsAPI ||
                                                    !estabelecimentoAtual.permiteRetiradaBalcao
                                                ) {
                                                    setAbrirCEP(true)
                                                } else {
                                                    setTelaRetiradaOuEntrega(true)
                                                }
                                            } else {
                                                setAbrirEnderecos(true)
                                            }
                                        }}
                                        style={{
                                            padding: "0px",
                                            color: `${aplicativoDados.corSitePrimaria}`,
                                        }}
                                    >
                                        {textos.alterarFormaEntrega}
                                    </Button>
                                )}
                            </div>
                            <br></br>
                            {!isUsuarioPedidoMesa && temEndereco ? (
                                <Typography style={{ textAlign: "center" }}>
                                    <span className="bold">{textos.entregarEm}:</span>
                                    {enderecoAtual.logradouro} - n°
                                    {enderecoAtual.numero} - Bairro {enderecoAtual.bairro} -
                                    {enderecoAtual.cidade} - {enderecoAtual.uf}
                                    <br />
                                    {enderecoAtual.complemento ? (
                                        <>
                                            <span className="bold"> {textos.complemento}: </span>
                                            {enderecoAtual.complemento}
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {enderecoAtual.referencia ? (
                                        <>
                                            <span className="bold"> {textos.referencia}: </span>
                                            {enderecoAtual.referencia}
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    <br />
                                </Typography>
                            ) : isRetiradaNoLocal ? (
                                <Typography style={{ textAlign: "center" }}>
                                    <b>{textos.retirarNoEstabelecimento}: </b>
                                    {estabelecimentoAtual.nome}
                                    <br />
                                    {textos.endereco}: {estabelecimentoAtual.endereco}
                                    <br />
                                    {textos.telefone}: {estabelecimentoAtual.telefone}
                                    <br />
                                </Typography>
                            ) : null}
                            {isUsuarioPedidoMesa ? (
                                <Typography
                                    style={{
                                        textAlign: "center",
                                        fontSize: "40px",
                                    }}
                                >
                                    {getNomeMesa()}
                                </Typography>
                            ) : null}

                            {solicitarNomeAoFinalizar && (
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    defaultValue={
                                        usuarioPedidoMesa?.logado
                                            ? usuarioPedidoMesa?.cliente?.nome != "Cliente"
                                                ? usuarioPedidoMesa?.cliente?.nome
                                                : ""
                                            : usuarioLogado?.cliente?.nome != "Cliente"
                                            ? usuarioLogado?.cliente?.nome
                                            : ""
                                    }
                                    id="nomePedido"
                                    label={textos.seuNome}
                                    name="nomePedido"
                                />
                            )}

                            {solicitarTelefoneAoFinalizar ? (
                                <TelefoneInputField id="telefonePedido" />
                            ) : null}

                            {usuarioPedidoMesa?.logado && !nomePadraoMesa ? (
                                isNumeric(mesa) || !mesa ? (
                                    <FormControl
                                        disabled={desabilitarInputMesa}
                                        variant="outlined"
                                        style={{ width: "100%", marginTop: "1.5em" }}
                                    >
                                        <InputLabel id="numeroDaMesaLabel">
                                            {textos.mesa}
                                        </InputLabel>
                                        <Select
                                            value={mesa ?? 0}
                                            onChange={e => setMesa(e.target.value)}
                                            labelId="numeroDaMesaLabel"
                                            id="numeroDaMesa"
                                            label={textos.mesa}
                                            fullWidth
                                        >
                                            <MenuItem key={0} value={0}>
                                                {textos.naoSelecionada}
                                            </MenuItem>
                                            {numeroMesas.map(num => (
                                                <MenuItem key={num} value={num}>
                                                    {textos.mesa} {num}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                ) : (
                                    <TextField
                                        disabled
                                        fullWidth
                                        value={mesa}
                                        label="Mesa"
                                        variant="outlined"
                                    />
                                )
                            ) : null}

                            <SelecaoFormaDePagamento
                                carrinho={carrinho}
                                alertStart={alertStart}
                                setLoading={setLoading}
                                setOpenTroco={setOpenTroco}
                                isUsuarioPedidoMesa={isUsuarioPedidoMesa}
                                isRetiradaNoLocal={isRetiradaNoLocal}
                                aplicativoDados={aplicativoDados}
                                isComerNoLocal={isComerNoLocal}
                                setAbrirDialogCadastroCartao={setAbrirDialogCadastroCartao}
                            />

                            <DisplayDetalhesCartao
                                setAbrirDialogCadastroCartao={setAbrirDialogCadastroCartao}
                            />

                            <ObservacoesPedido
                                isUsuarioPedidoMesa={isUsuarioPedidoMesa}
                                textoObservacao={textoObservacao}
                                setAbrirObservacoes={setAbrirObservacoes}
                                emailCliente={usuarioLogado?.cliente?.email}
                                alertStart={alertStart}
                                isComerNoLocal={isComerNoLocal}
                                setIsComerNoLocal={setIsComerNoLocal}
                                mostrarComerNoLocal={mostrarComerNoLocal}
                                cpf={props.cpf}
                                setCpf={props.setCpf}
                            />

                            <Typography>
                                {textos.produtos}: + {formatarParaDinheiro(valorProdutos)}
                                <br />
                                {valorDesconto ? (
                                    <>
                                        {textos.descontos}: -
                                        {formatarParaDinheiro(
                                            Math.abs(valorDesconto ? valorDesconto : 0)
                                        )}
                                        <br />
                                    </>
                                ) : null}
                                {valorAcrescimo ? (
                                    <>
                                        {textos.acrescimos}: +
                                        {formatarParaDinheiro(Math.abs(valorAcrescimo))}
                                        <br />
                                    </>
                                ) : null}
                                {isEntregaNoEndereco && <TaxaEntregaFormatada />}
                                {parametros.PUBLIC_TAXA_ADICIONAL ? (
                                    <Tooltip title="Taxa de serviço cobrada em todos os pedidos realizados pela plataforma.">
                                        <span style={{ position: "relative" }}>
                                            {textos.taxaAdicional}: +{" "}
                                            {formatarParaDinheiro(parametros.PUBLIC_TAXA_ADICIONAL)}
                                            <InfoIcon
                                                style={{
                                                    fontSize: "0.75rem",
                                                    position: "absolute",
                                                    top: "0",
                                                    right: "-0.85rem",
                                                }}
                                            />
                                            <br />
                                        </span>
                                    </Tooltip>
                                ) : null}
                                <b>
                                    {textos.valorFinal} ={" "}
                                    {formatarParaDinheiro(carrinho.pedido.valorTotal)}
                                </b>
                                <br />
                            </Typography>
                        </DialogContent>
                        <DialogActions style={{ flexDirection: "column" }}>
                            {continuarSemCadastro ? (
                                <Row style={{ margin: "0px 0px 1em 0px", width: "100%" }}>
                                    <Col
                                        xs={12}
                                        md={12}
                                        lg={12}
                                        style={{ padding: 0 }}
                                        onClick={() => {
                                            setQueroMeCadastrar(!queroMeCadastrar)
                                        }}
                                    >
                                        <AlertFixo
                                            icon={
                                                <Checkbox
                                                    style={{ padding: 0 }}
                                                    checked={queroMeCadastrar}
                                                    color="default"
                                                    onChange={() =>
                                                        setQueroMeCadastrar(!queroMeCadastrar)
                                                    }
                                                />
                                            }
                                            className="campoDeUmAlert"
                                            severity={
                                                queroMeCadastrar === false ? "error" : "success"
                                            }
                                        >
                                            {textos.queroMeCadastrar}
                                        </AlertFixo>
                                    </Col>
                                </Row>
                            ) : null}

                            {confirmeiPagamentoOnline === false &&
                            cardapio?.mensagemConfirmacaoPagamentoOnline &&
                            carrinho?.pedido?.formaPagamento?.id === 40 ? (
                                <Row style={{ margin: "0px 0px 1em 0px", width: "100%" }}>
                                    <Col xs={12} md={12} lg={12} style={{ padding: 0 }}>
                                        <AlertFixo
                                            icon={
                                                <Checkbox
                                                    style={{ padding: 0 }}
                                                    checked={confirmeiPagamentoOnline}
                                                    color="default"
                                                    onChange={() =>
                                                        setConfirmeiPagamentoOnline(
                                                            !confirmeiPagamentoOnline
                                                        )
                                                    }
                                                />
                                            }
                                            className="campoDeUmAlert"
                                            severity={
                                                confirmeiPagamentoOnline === false
                                                    ? "error"
                                                    : "success"
                                            }
                                        >
                                            {cardapio?.mensagemConfirmacaoPagamentoOnline}
                                        </AlertFixo>
                                    </Col>
                                </Row>
                            ) : null}

                            <Button
                                fullWidth
                                size="large"
                                disabled={loading}
                                variant="contained"
                                style={{ background: "#28a745", color: "white" }}
                                onClick={enviarPedidoHandler}
                            >
                                {textos.enviarPedido}
                                <span className="valorFinalizarPedido">
                                    {formatarParaDinheiro(
                                        carrinho.pedido.valorTotal
                                            ? carrinho.pedido.valorTotal
                                            : 0.0
                                    )}
                                </span>
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            ) : null}

            <Dialog open={openTroco} aria-labelledby="trocoModal" maxWidth="xs" fullWidth>
                <img src={aplicativoDados.urlLogo} className="imgModal" />

                <DialogTitle id="informarcoesImportantes">
                    <IconButton
                        className="setaVoltarModal"
                        onClick={() => {
                            setOpenTroco(false)
                        }}
                    >
                        <ArrowForwardIosIcon />
                    </IconButton>
                    {textos.perguntaPrecisaTroco}
                </DialogTitle>

                <DialogContent>
                    <Typography>
                        {textos.valorPedido}{" "}
                        <b>{formatarParaDinheiro(carrinho?.pedido?.valorTotal)}</b>
                    </Typography>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        autoFocus
                        InputProps={{
                            inputComponent: TrocoMask,
                        }}
                        id="valorTroco"
                        label={textos.trocoParaQuanto}
                        name="valorTroco"
                    />
                </DialogContent>
                <DialogActions className={classes.buttonContainer}>
                    <Button variant="contained" onClick={naoPrecisoDeTroco}>
                        {textos.naoPrecisoTroco}
                    </Button>
                    <Button
                        onClick={prontoTroco}
                        style={{ backgroundColor: "#28a745", color: "white" }}
                    >
                        {textos.confirmar}
                    </Button>
                </DialogActions>
            </Dialog>

            <DialogEnderecos
                abrirEnderecos={abrirEnderecos}
                setAbrirEnderecos={setAbrirEnderecos}
                abrirCEP={abrirCEP}
                setAbrirCEP={setAbrirCEP}
                selecioneiRetiradaNoLocal={selecioneiRetiradaNoLocal}
                buscarCardapio={buscarCardapio}
                DialogConfirmacaoinformacoes={DialogConfirmacaoinformacoes}
            />

            <DialogCEP
                abrirCEP={abrirCEP}
                setAbrirCEP={setAbrirCEP}
                abrirNovoEndereco={abrirNovoEndereco}
                setAbrirNovoEndereco={setAbrirNovoEndereco}
                setEnderecoCadastrado={setEnderecoCadastrado}
                setCepFoiCadastrado={setCepFoiCadastrado}
                alertStart={alertStart}
                selecioneiRetiradaNoLocal={selecioneiRetiradaNoLocal}
                DialogConfirmacaoinformacoes={DialogConfirmacaoinformacoes}
            />

            <DialogNovoEndereco
                abrirNovoEndereco={abrirNovoEndereco}
                setAbrirNovoEndereco={setAbrirNovoEndereco}
                abrirCEP={abrirCEP}
                setAbrirCEP={setAbrirCEP}
                abrirEnderecos={abrirEnderecos}
                setAbrirEnderecos={setAbrirEnderecos}
                alertStart={alertStart}
                enderecoCadastrado={enderecoCadastrado}
                cepFoiCadastrado={cepFoiCadastrado}
                setCepFoiCadastrado={setCepFoiCadastrado}
                continuarSemCadastro={continuarSemCadastro}
                estabelecimentoAtual={estabelecimentoAtual}
                setTelaRetiradaOuEntrega={setTelaRetiradaOuEntrega}
                buscarCardapio={buscarCardapio}
                DialogConfirmacaoinformacoes={DialogConfirmacaoinformacoes}
            />

            <DialogObservacoes
                abrirObservacoes={abrirObservacoes}
                setAbrirObservacoes={setAbrirObservacoes}
                textoObservacao={textoObservacao}
                setTextoObservacao={setTextoObservacao}
            />

            {cardapio.id ? (
                <>
                    <Dialog
                        open={InformacoesDoTipoEntrega}
                        onClose={() => setInformacoesDoTipoEntrega(false)}
                        aria-labelledby="informacoesFormaDeEntregaModal"
                    >
                        <img src={aplicativoDados.urlLogo} className="imgModal" />

                        {usuarioLogado?.logado ? (
                            <DialogTitle id="informacoesFormaDeEntregaModal">
                                <IconButton
                                    className="setaVoltarModal"
                                    onClick={() => {
                                        setInformacoesDoTipoEntrega(false)
                                    }}
                                >
                                    <ArrowForwardIosIcon />
                                </IconButton>
                                {isRetiradaNoLocal ? textos.paraRetirada : textos.paraEntrega}
                            </DialogTitle>
                        ) : (
                            <DialogTitle id="informacoesFormaDeEntregaModal">
                                <IconButton
                                    className="setaVoltarModal"
                                    onClick={() => {
                                        setInformacoesDoTipoEntrega(false)
                                    }}
                                >
                                    <ArrowForwardIosIcon />
                                </IconButton>
                                {textos.voceNaoEstaLogado}
                            </DialogTitle>
                        )}

                        <DialogContent>
                            <Typography>
                                {aplicativoDados?.permitirContinuarSemCadastro
                                    ? textos.perguntaCriacaoUsuario
                                    : textos.criacaoUsuarioObrigatorio}
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            {
                                // true
                                aplicativoDados?.permitirContinuarSemCadastro ? (
                                    <Button
                                        fullWidth
                                        onClick={() => {
                                            window.dispatchEvent(
                                                new CustomEvent("continuarSemCadastro")
                                            )
                                            setInformacoesDoTipoEntrega(false)
                                            DialogConfirmacaoinformacoes(true)
                                        }}
                                        style={{ color: "#dc3545" }}
                                    >
                                        {textos.naoQueroCadastrar}
                                    </Button>
                                ) : null
                            }

                            {usuarioLogado?.logado ? (
                                /* LOGADO */ <Button
                                    fullWidth
                                    onClick={() => {
                                        setAbrirEnderecos(true)
                                    }}
                                    style={{ backgroundColor: "#28a745", color: "white" }}
                                >
                                    {isRetiradaNoLocal || temEndereco
                                        ? textos.alterar
                                        : textos.adicionar}
                                </Button>
                            ) : (
                                /* DESLOGADO */ <Button
                                    fullWidth
                                    onClick={() => setAbrirDialogLogin(true)}
                                    style={{ color: "white", backgroundColor: "#28a745" }}
                                >
                                    {aplicativoDados?.permitirContinuarSemCadastro
                                        ? textos.queroCadastrar
                                        : textos.fazerLogin}
                                </Button>
                            )}
                        </DialogActions>
                    </Dialog>

                    {openTelaLogin.open ? (
                        <Dialog
                            open={openTelaLogin.open}
                            onClose={() => {
                                setOpenTelaLogin(false)
                            }}
                            aria-labelledby="MostrarFotoProdutoModal"
                        >
                            <DialogTitle id="informarcoesImportantes">
                                <IconButton
                                    className="setaVoltarModal"
                                    onClick={() => {
                                        setOpenTelaLogin(false)
                                    }}
                                >
                                    <ArrowForwardIosIcon />
                                </IconButton>
                                {textos.facaLogin}
                            </DialogTitle>
                            <DialogContent style={{ textAlign: "center" }}>
                                <TelaLogin
                                    telefone={openTelaLogin.telefone}
                                    nome={openTelaLogin.nome}
                                    location={window.location}
                                    telaCardapio={true}
                                    queroMeCadastrar={queroMeCadastrar}
                                    setOpenTelaLogin={setOpenTelaLogin}
                                    confirmacaoInformacoes={confirmacaoInformacoes}
                                />
                            </DialogContent>
                            {/* <DialogActions>
                <Button onClick={() => {
                                setQueroMeCadastrar(false)
                            }} style={{ "color": "#dc3545" }}>
                                Voltar
                            </Button>
                        </DialogActions> */}
                        </Dialog>
                    ) : null}

                    <Dialog
                        open={AbrirMostrarFotoProduto}
                        aria-labelledby="MostrarFotoProdutoModal"
                    >
                        <DialogContent style={{ textAlign: "center" }}>
                            <img
                                className={MostrarFotoProduto.urlImagem ? "" : "opacity05"}
                                style={{ width: "250px" }}
                                alt={MostrarFotoProduto.nome}
                                src={
                                    MostrarFotoProduto.urlImagem
                                        ? MostrarFotoProduto.urlImagem
                                        : MostrarFotoProduto.produtoExibicao
                                        ? Megafone
                                        : /**Prato */ Comida
                                }
                            />
                            <Typography component="h5" variant="h5">
                                {MostrarFotoProduto.nome}
                            </Typography>
                            <Typography variant="subtitle1" color="textSecondary">
                                {MostrarFotoProduto.descricao}
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            {MostrarFotoProduto.produtoExibicao ? null : (
                                <Button
                                    style={{ zIndex: "10001" }}
                                    onClick={() => {
                                        if (isEntregaNoEndereco === false && temEndereco) {
                                            setAbrirEnderecos(true)
                                        } else {
                                            irParaProduto(MostrarFotoProduto.id)
                                        }
                                    }}
                                    style={{ color: "#28a745" }}
                                >
                                    {textos.adicionar}
                                </Button>
                            )}
                            <Button
                                onClick={() => {
                                    setAbrirMostrarFotoProduto(false)
                                }}
                                style={{ color: "#dc3545" }}
                            >
                                {textos.voltar}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={TelaRetiradaOuEntrega}
                        fullWidth
                        onClose={() => {
                            setTelaRetiradaOuEntrega(false)
                        }}
                        aria-labelledby="TelaRetiradaOuEntregaModal"
                        // style={{'zIndex': 10000}}
                    >
                        <img src={aplicativoDados.urlLogo} className="imgModal" />

                        <DialogTitle id="informarcoesImportantes">
                            <IconButton
                                className="setaVoltarModal"
                                onClick={() => {
                                    setTelaRetiradaOuEntrega(false)
                                }}
                            >
                                <ArrowForwardIosIcon />
                            </IconButton>
                            {textos.opcoesEntrega}
                        </DialogTitle>

                        <DialogContent style={{ textAlign: "center" }}>
                            {isEntregaNoEndereco === false && temEndereco ? (
                                <>
                                    <AlertFixo
                                        className="campoDeUmAlert"
                                        onClick={() => {
                                            setAbrirEnderecos(true)
                                        }}
                                        severity="error"
                                    >
                                        {textos.naoEntregaEndereco}
                                        <b>
                                            {enderecoAtual.logradouro}, {enderecoAtual.numero} -
                                            {enderecoAtual.bairro}
                                        </b>
                                        <Button
                                            onClick={() => {
                                                setAbrirEnderecos(true)
                                            }}
                                            style={{ padding: "0px", fontSize: "80%" }}
                                        >
                                            {textos.trocar}
                                        </Button>
                                    </AlertFixo>

                                    {outrosEstabelecimentosEntregam.length ? (
                                        <AlertFixo
                                            style={{ margin: "0.5em 0" }}
                                            className="campoDeUmAlert"
                                            onClick={() => {}}
                                            severity="warning"
                                        >
                                            {textos.existeOutroEstabelecimento}
                                            <Button
                                                style={{ padding: "0px", fontSize: "80%" }}
                                                onClick={() => {
                                                    history.push("/lojas")
                                                }}
                                            >
                                                {textos.trocar}
                                            </Button>
                                        </AlertFixo>
                                    ) : null}
                                </>
                            ) : null}

                            <Button
                                variant="contained"
                                onClick={() => {
                                    selecioneiRetiradaNoLocal()
                                    DialogConfirmacaoinformacoes(true)
                                }}
                                style={{
                                    background: `#28a745`,
                                    color: "white",
                                    margin: "5px 10px",
                                }}
                            >
                                {textos.paraRetirada}
                            </Button>

                            <Button
                                variant="contained"
                                onClick={() => {
                                    if (continuarSemCadastro) {
                                        setAbrirCEP(true)
                                    } else setAbrirEnderecos(true)
                                }}
                                style={{ background: `#28a745`, color: "white" }}
                            >
                                {textos.paraEntrega}
                            </Button>

                            {!aplicativoDados?.permitirDesconectarMesa ? (
                                <Button
                                    style={{
                                        background: `#28a745`,
                                        color: "white",
                                        margin: "5px 10px",
                                    }}
                                    variant="contained"
                                    onClick={() => {
                                        var mesa = "--"
                                        history.push(
                                            `/login/pedidoMesa?loja=${estabelecimentoAtual.id}&mesa=${mesa}`
                                        )
                                    }}
                                >
                                    {textos.paraMesa}
                                </Button>
                            ) : null}
                        </DialogContent>
                    </Dialog>
                </>
            ) : null}
            <DialogCadastroCartao
                abrirDialogCadastroCartao={abrirDialogCadastroCartao}
                setAbrirDialogCadastroCartao={setAbrirDialogCadastroCartao}
                alertStart={alertStart}
                setLoading={setLoading}
            />
        </>
    )
}
